import Card from "react-bootstrap/Card";
import React from "react";
import "./Projects.css";
import JSweather from "./JSweather.png";
import Reactweather from "./Reactweather.png";
import Reactdictionary from "./Reactdictionary.png";
  
export default function App() {
  return (
    <div className="Project-card">
      <div className="Dictionary-card">
      <Card style={{ width: "15rem" }}>
        <Card.Body>
          <img class="card-img-top" src={Reactdictionary} alt="React dictionary app"></img>
          <Card.Title style={{ color: "black" }}>React</Card.Title>
          <Card.Subtitle className="mb-2 text-muted">
            Dictionary application
          </Card.Subtitle>
          <Card.Text>
            Integrates 2 APIs for the word meaning as well as image results.
          </Card.Text>
          <Card.Link href="https://distracted-yonath-1c9581.netlify.app/" className="Dictionary-link" target="_blank"> View project </Card.Link>
        </Card.Body>
      </Card>
      </div>
      <div className="React-weather-card">
      <Card style={{ width: "15rem" }}>
        <Card.Body>
          <img class="card-img-top" src={Reactweather} alt="React weather app"></img>
          <Card.Title style={{ color: "black" }}>React</Card.Title>
          <Card.Subtitle className="mb-2 text-muted">
            Weather application
          </Card.Subtitle>
          <Card.Text>
            Converted Vanilla JS app to ReactJS app with API integration.
          </Card.Text>
          <Card.Link href="https://serene-varahamihira-8a40e2.netlify.app/" className="React-weather-link" target="_blank"> View project </Card.Link>
        </Card.Body>
      </Card>
      </div>
      <div className="Js-weather-card">
      <Card style={{ width: "15rem" }}>
        <Card.Body>
          <img class="card-img-top" src={JSweather} alt=" JS weather app"></img>
          <Card.Title style={{ color: "black" }}>Vanilla JS</Card.Title>
          <Card.Subtitle className="mb-2 text-muted">
            Weather application
          </Card.Subtitle>
          <Card.Text>
            Integrated search engine and weather forecasting API.
          </Card.Text>
          <Card.Link href="https://vigorous-wiles-1196e9.netlify.app/" className="Js-weather-link" target="_blank"> View project </Card.Link>
        </Card.Body>
      </Card>
      </div>
    </div>
    
  );
}